import BulletPointsCard from '../BulletPointsCard'
import Star from '../../Icons/coaching/star.svg'
import Mailer from '../../Icons/coaching/mailer.svg'

const bulletPoints = [
    {
        title: 'Mailer Selection',
        description:
            'Collaborate with our team to choose the most effective mail pieces based on successful campaigns in your market.',
        icon: Mailer,
    },
    {
        title: 'Content Best Practices',
        description:
            'Discover what content works best on your mailers and what to avoid to ensure maximum impact.',
        icon: Star,
    },
]

function Effective(props) {
    return (
        <BulletPointsCard
            {...props}
            title="Effective Mail Pieces"
            bulletPoints={bulletPoints}
            imagePath="/assets/coaching/effective.png"
            imageAlt="An overhead shot of multiple hands pointing at six circular coasters on a table, each with a different business or finance icon like a dollar sign, a chart, and a lock. The coasters sit on papers with charts and data."
            imageTitle="A team brainstorming or collaborating on business strategy."
            mobileImagePath={'/assets/coaching/3-mobile.png'}
            alignment={'left'}
            bg="bg-light-yellow-gradient"
        />
    )
}

export default Effective
